import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import Fold from './Fold';
import { DetailItem, Amount, Detail, priceRender } from './TradeDetailPaymentLazada';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

/** shopee 买家实付金额 */
function TradePaymentAmountShopee(props: TradeIncomeAmountProps) {
  const { trade, defaultFold = true, className, ...otherProps } = props;

  const { unit, buyerPayment } = trade;

  const { t } = useTranslate();

  const [isfold, setIsfold] = useState(defaultFold);

  const total = priceRender(buyerPayment?.buyerTotalAmount, (val) => {
    return (
      <DetailItem
        key="total"
        onClick={() => setIsfold((isfold) => !isfold)}
        style={
          className === 'tradeDetail'
            ? {
                border: '1px solid var(--fett-border-default)',
                padding: '0 16px',
                lineHeight: '40px',
              }
            : {}
        }
      >
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('domain.order.payment.field.buyerTotal')}
        </span>
        {className !== 'tradeDetail' ? (
          <Amount isfold={isfold}>
            <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
            <DownOutlined />
          </Amount>
        ) : null}
      </DetailItem>
    );
  });

  const detail = (
    <Detail
      key="detail"
      style={
        className === 'tradeDetail'
          ? { background: 'none', border: '1px solid var(--fett-bg-app)', borderTop: 'none' }
          : {}
      }
    >
      {priceRender(buyerPayment?.itemPrice, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.productAmount')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.productProtection, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.productInsurance')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerPaidShippingFee, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.shippingFee')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.shippingFeeSst, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.buyerShippingSst')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.voucherFromPlatform, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.shopeeProductSubsidy')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.voucherFromSeller, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.sellerVoucher')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.coins, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.shopeeCoinDiscount')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.creditCardPromotion, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.creditCardDiscount')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.crossBorderTax, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.importTax')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.icmsTax, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.icms')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.otherTaxes, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.otherTaxes')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.serviceFee, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.serviceFee')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerTransactionFee, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.buyerTransactionFee')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerTotalAmount, (val) => {
        return (
          <li>
            <dt>{t('domain.order.payment.field.buyerTotal')}</dt>
            <dd className="colorFont">{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
    </Detail>
  );
  return total ? (
    <Fold
      isfold={isfold}
      fixedCount={1}
      nodeList={[total, detail]}
      defaultFixedHeight={32}
      {...otherProps}
      style={className === 'tradeDetail' ? { marginBottom: '16px' } : {}}
    />
  ) : null;
}

export default memo(TradePaymentAmountShopee);
